// Used in basics track (gender, MyCRC) and gender track to list
const genderXCheck = (data) =>
    (data.request_criminal_record_check ||
        data.request_enhanced_criminal_record_check ||
        data.request_vulnerable_sector_criminal_record_check ||
        data.request_australian_criminal_intelligence_commission_check) &&
    !data.request_international_criminal_record_check;

export default genderXCheck;
